module.exports = __webpack_public_path__ + "static/media/sai-logo.ea813f1a.png";